import React from "react"
import { ready, renderAtMountpoint, renderAtAllMountpoints } from "../shared/utils"
import { QuestionnaireData } from "../questionnaire"

import "./application.scss"
import "../payment/card_token"
import "./common"

import { UserRequest } from "../data/Request"
import { RequestKindSettings } from "../shared/settings"

ready(() => {
  renderAtAllMountpoints('.date-input-field', async (el) => {
    const { default: DateInputField } = await import('../form/DateInputField')
    const name = el.dataset.name
    const className = el.dataset.class
    const defaultValue = el.dataset.defaultValue
    return <DateInputField
      className={className}
      name={name}
      defaultValue={defaultValue}
    />
  })
  renderAtMountpoint("request-edit", async (el) => {
    const { default: RequestEdit } = await import('./RequestEdit')
    const request = JSON.parse(el.dataset.requestJson) as UserRequest
    return <RequestEdit request={request} />
  })

  renderAtMountpoint("patient-conference-wrapper", async (el) => {
    const { default: PatientConference } = await import('./PatientConference')
    const requestId = parseInt(el.dataset.requestId)
    return <PatientConference requestId={requestId} />
  })
  renderAtMountpoint("terms-of-request", async (el) => {
    const { default: RequestTerms } = await import('./RequestTerms')
    const terms = el.dataset.terms
    const kind = el.dataset.kind
    const requestKindSettings = JSON.parse(el.dataset.kindData) as RequestKindSettings
    const brandName = el.dataset.brandName

    return <RequestTerms
      requestEndpoint={el.dataset.requestEndpoint}
      terms={terms}
      kind={kind}
      brandName={brandName}
      requestKindSettings={requestKindSettings}
    />
  })
  renderAtMountpoint("credit-card-edit", async () => {
    const { default: CreditCardEdit } = await import('./CreditCardEdit')
    return <CreditCardEdit />
  })

  renderAtMountpoint("request-extra-participant", async (el) => {
    const { default: RequestExtraParticipant } = await import('./RequestExtraParticipant')
    return <RequestExtraParticipant
      screenSharingAvailable={!!el.dataset.screenSharing}
    />
  })
  renderAtMountpoint("scheduled-conference-view", async (el) => {
    const { default: ScheduledConferenceView } = await import('./ScheduledConferenceView')
    return <ScheduledConferenceView
      tokenPath={el.dataset.tokenPath}
      participantIdentityPath={el.dataset.participantIdentityPath}
      screenSharingAvailable={!!el.dataset.screenSharing}
    />
  })
  renderAtMountpoint("user-activation-code", async (el) => {
    const { default: UserActivationCode } = await import('./UserActivationCode')
    return <UserActivationCode
      codeClass={el.dataset.codeClass}
    />
  })

  renderAtMountpoint("alert-deprecated-browser", async () => {
    const { default: AlertDeprecatedBrowser } = await import('./AlertDeprecatedBrowser')
    return <AlertDeprecatedBrowser />
  })

  renderAtMountpoint('request-upload-form', async (el) => {
    const { default: RequestUploadForm } = await import('../shared/RequestUploadForm')
    const definitionJson = JSON.parse(el.dataset.definition) as QuestionnaireData
    const requestId = parseInt(el.dataset.requestId)
    const conferenceId = parseInt(el.dataset.conferenceId)

    // this form doesn't have an answer
    return <RequestUploadForm
      requestId={requestId}
      conferenceId={conferenceId}
      definition={definitionJson}
    />
  })

})
